import CONSTANT from './constant.js'

/**
 * 크롬 익스텐션을 종류별로 필터링 해서 fingerprint 합니다.
 * @returns {string[]}
 */
function filterChromeExtensions(stackString) {
  if (typeof stackString !== 'string') return []
  const groups = []
  const chromeExtensionIndex = stackString.indexOf(`${CONSTANT.ISSUE_GROUP.CHROME_EXTENSION}://`)
  if (chromeExtensionIndex !== -1) {
    groups.push(CONSTANT.ISSUE_GROUP.CHROME_EXTENSION)

    let ceEol = stackString.indexOf('\n', chromeExtensionIndex)
    if (ceEol === -1) {
      ceEol = stackString.length
    }
    const ceLine = stackString.substring(chromeExtensionIndex, ceEol)
    try {
      const chromeExtensionUrl = new URL(ceLine)
      const { searchParams, host: extensionName } = chromeExtensionUrl

      groups.push(extensionName)
      if (extensionName === CONSTANT.ISSUE_GROUP.TAMPERMONKEY) {
        const userScriptName = searchParams.get('name')
        if (userScriptName) groups.push(userScriptName)
      }
    } catch (error) {
      console.warn(error)
    }
  }

  return groups
}

/**
 * 이슈 그루핑을 위해 event 정보에 따라 분류해서 fingerprint 룰에 적용 할 수 있도록 string[]를 반환합니다.
 * @see https://docs.sentry.io/product/data-management-settings/event-grouping/
 * @returns {string[]}
 */
export default function groupIssues(event, hint) {
  const stackString = typeof hint?.originalException?.stack === 'string' ? hint?.originalException?.stack : null

  const fingerprint = [
    ...filterChromeExtensions(stackString),
  ]

  return fingerprint
}
